import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const UnauthRoute = ({component: Component, loggedIn, ...rest}) => {
	return (
		<Route {...rest} render={(props) => (
			loggedIn ?
				<Redirect to="/admins" />
			:
				<Component {...props} />
		)} />
	);
};

export default UnauthRoute;